import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useSnackbar } from '@e3dc-react/shell/Hooks/Snackbar'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { releaseInstallationStatement } from 'src/Libs/installation-statement/api/installation-statement.api'

export const useReleaseInstallationStatement = (): {
  releaseInstallationStatement: (installationId: string | undefined, deviceLinkId: string) => Promise<void>
} => {
  const authFetch = useAuthFetchWithResponse()
  const { t } = useCustomTranslation()
  const { enqueueErrorStack, enqueueSuccessStack } = useSnackbar()

  const releaseStatement = async (installationId: string | undefined, deviceLinkId: string): Promise<void> => {
    try {
      await releaseInstallationStatement(installationId, deviceLinkId, authFetch)
      enqueueSuccessStack(t('system-details.installation-statements.release.success'))
    } catch (error) {
      enqueueErrorStack(t('system-details.installation-statements.release.error'))
    }
  }

  return { releaseInstallationStatement: releaseStatement }
}
